import React from "react";

/**
 * Adds support for React StrictMode when using MUI components
 * This resolves issues with addEventListener in MUI's focus tracking
 */
const StrictModeHandler = ({ children }) => {
  const [isMounted, setIsMounted] = React.useState(false);

  // This helps prevent MUI's addEventListener errors in StrictMode
  React.useLayoutEffect(() => {
    // Set a small timeout to ensure document is fully ready
    const timer = setTimeout(() => {
      setIsMounted(true);
    }, 0);
    return () => clearTimeout(timer);
  }, []);

  // By adding this condition, we ensure MUI components render
  // only after the document is ready
  if (!isMounted || typeof document === "undefined") {
    // Return a placeholder during the first render
    return <div style={{ display: "none" }}></div>;
  }

  return <>{children}</>;
};

export default StrictModeHandler;
